import { CLEAR_SITE_DATA } from '../application';
import {
  LOADING_STATE_SETS,
  SAVE_STATE_SET,
  STATE_SET_SAVED,
  RECEIVED_STATE_SETS,
  UPDATE_STATE_SETS,
} from './actions';

// INITAL STATES

const initalState = {
  loadingSaveStateSet: false,
  loadingStates: false,
  stateSets: [],
  siteLoaded: undefined,
};

// eslint-disable-next-line default-param-last
export const reducer = (state = initalState, action) => {
  switch (action.type) {
    case SAVE_STATE_SET: {
      return { ...state, loadingSaveStateSet: true };
    }
    case STATE_SET_SAVED: {
      return { ...state, loadingSaveStateSet: false };
    }
    case LOADING_STATE_SETS: {
      return { ...state, loadingStates: true };
    }
    case RECEIVED_STATE_SETS: {
      return {
        ...state,
        loadingStates: false,
        stateSets: action.stateSets,
        siteLoaded: action.siteId || state.siteLoaded,
      };
    }
    case UPDATE_STATE_SETS: {
      return {
        ...state,
        loadingSaveStateSet: true,
        stateSet: action.stateSet,
      };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        loadingSaveStateSet: false,
        loadingStates: false,
        stateSets: [],
        siteLoaded: undefined,
      };
    }
    default:
      return state;
  }
};

export default reducer;
